import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder
import qs from 'qs'

// 批量复核
export function batCheckCost(data) {
    return request({
        url: serviceName + `/depa/cost_check_bat`,
        method: 'post',
        data: data
    })
}